import React, { useState, useEffect } from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';
import { Icon, ICONS } from 'components/Icons';
import classNames from 'classnames';

import QuestionText from './QuestionText';

import './LocationPicker.scss';

const REACT_APP_GOOGLE_API_PLACES = process.env.REACT_APP_GOOGLE_API_PLACES;

export default function LocationPicker({
  question,
  onChange,
  model,
  autoFocus = false,
  shouldDisabled,
}) {
  const [input, setInput] = useState('');
  const [selectedPlace, setSelectedPlace] = useState(null);

  const value = model[question.variable];
  const single = question.single;
  const noHomeCity = question.noHomeCity;
  const noCurrentCity = question.noCurrentCity;

  function renderText() {
    return <QuestionText question={question} />;
  }

  function picker() {
    const location = getValue();

    const isSingleLocationPicked =
      single && Array.isArray(location) && location.length;

    return (
      <div className="form-control-container position-relative">
        <input
          ref={ref}
          type="text"
          className="form-control"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={isSingleLocationPicked ? '' : 'Search for location'}
          autoFocus={autoFocus}
          disabled={
            isSingleLocationPicked ||
            (shouldDisabled ? shouldDisabled(question) : false)
          }
        />
        {isSingleLocationPicked ? renderLocation(location[0]) : null}
      </div>
    );
  }

  function getValue() {
    const defaultValue = [];

    return value || defaultValue;
  }

  function onLocationSelection(address) {
    const addressData = { ...address };

    return onChange([...getValue(), addressData]);
  }

  useEffect(() => {
    if (selectedPlace) {
      onLocationSelection(selectedPlace);
      setInput('');
      setSelectedPlace(null);
    }
  }, [selectedPlace]);

  const { ref } = usePlacesWidget({
    apiKey: REACT_APP_GOOGLE_API_PLACES,
    onPlaceSelected: (place) => {
      if (!place || !Array.isArray(place.address_components)) {
        return;
      }
      const address_components = place.address_components;

      const country = address_components.find(
        (c) => c.types.indexOf('country') > -1,
      );
      const state = address_components.find(
        (c) => c.types.indexOf('administrative_area_level_1') > -1,
      );
      const city = address_components.find(
        (c) =>
          c.types.indexOf('locality') > -1 ||
          c.types.indexOf('administrative_area_level_2') > -1,
      );

      const address = {
        id: new Date().getTime(),
        country: country ? country.long_name : '',
        state: state ? state.long_name : '',
        city: city ? city.long_name : '',
        countryCode: country ? country.short_name : '',
        isHome: false,
        isCurrent: false,
      };

      setSelectedPlace(address);
    },
  });

  const mark = (id, isHome = false) => {
    let places = JSON.parse(JSON.stringify(getValue()));

    if (isHome) {
      places = places.map((place) => ({
        ...place,
        isHome: place.id === id ? true : false,
      }));
    } else {
      places = places.map((place) => ({
        ...place,
        isCurrent: place.id === id ? true : false,
      }));
    }

    onChange(places);
  };

  const remove = (id) => {
    let places = JSON.parse(JSON.stringify(getValue()));

    places = places.filter((p) => p.id !== id);

    onChange(places);
  };

  function showHeader() {
    // const location = getValue();

    // if (!Array.isArray(location) || location.length === 0) {
    //   return;
    // }

    return (
      <div className="container header">
        <div className="row">
          <div className="col-xs-7 place">Place</div>
          {!noHomeCity && <div className="col-xs-2 homeCity">Home City</div>}
          {!noCurrentCity && (
            <div className="col-xs-2 currentCity">Current City</div>
          )}
          <div className="col-xs-1 remove" />
        </div>
      </div>
    );
  }

  const renderLocation = (l) => {
    return (
      <div className="container places">
        <div className="row">
          <div className="col-xs-7 place">
            <Icon className="icon" icon={ICONS.LOCATION} size={14} />
            <div key={l.city} className="user-selected-location">
              {l.city}, {l.state}, {l.country}, {l.countryCode}
            </div>
          </div>
          {!noHomeCity && (
            <div className="col-xs-2 homeCity">
              <input
                type="radio"
                onChange={() => mark(l.id, true)}
                checked={l.isHome}
              />
            </div>
          )}
          {!noCurrentCity && (
            <div className="col-xs-2 currentCity">
              <input
                type="radio"
                onChange={() => mark(l.id)}
                checked={l.isCurrent}
              />
            </div>
          )}
          <div className="col-xs-1 remove">
            <Icon
              className="icon cursor-pointer"
              icon={ICONS.CLOSE}
              size={10}
              onClick={() => remove(l.id)}
            />
          </div>
        </div>
      </div>
    );
  };

  function showLocations() {
    if (single) {
      return null;
    }

    const location = getValue();

    if (!Array.isArray(location) || location.length === 0) {
      return;
    }

    return (
      <>
        {showHeader()}
        {location.map((l) => renderLocation(l))}
      </>
    );
  }

  const containerClassNames = classNames('question location-picker', {});
  return (
    <div className={containerClassNames}>
      {renderText()}
      {picker()}
      {/* {showHeader()} */}
      {showLocations()}
    </div>
  );
}
